/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.16.0
 * @since 1.12.0
 */

import { FC, ReactNode } from 'react';

import classNames from 'classnames';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { CSSProperties } from 'styled-components';

import { IRootReducer } from '../../../reducers/rootReducer';
import { Loader } from '../../loader/components/Loader';
import { makeSelectorModalStatus } from '../modalSelectors';
import { EModalStatus } from '../types/modalTypes';
import {
    IModalComposition,
    ModalBody,
    ModalCompoundControl,
    ModalCompoundStatus,
    ModalCompoundText,
    ModalCompoundTitle,
} from './ModalCompounds';
import ModalContext from './ModalContext';
import { IModalPopup } from './ModalPopup';
import { IModalPopupContainerStyled, ModalPopupContainerStyled } from './styled/ModalStyled';

interface IModalProps extends IModalPopupContainerStyled, Pick<IModalPopup, 'dataName'> {
    children: ReactNode;
    withoutPadding?: boolean;
    style?: CSSProperties;
}

const Modal: FC<IConnectedProps & IModalProps> & IModalComposition = ({
                                                                          children,
                                                                          dataName,
                                                                          status,
                                                                          style,
                                                                          width,
                                                                          withoutPadding,
                                                                      }) => {

    return (
        <ModalPopupContainerStyled
            className={classNames('modal-popup-container', {
                'modal-popup-container_without-padding': withoutPadding,
            })}
            data-component="modal-popup"
            data-name={dataName || ''}
            data-testid="campaign-info-modal"
            style={style}
            width={width}
        >
            <ModalContext.Provider value={{ status }}>
                <Loader showLoader={status === EModalStatus.processing}>
                    {children}
                </Loader>
            </ModalContext.Provider>
        </ModalPopupContainerStyled>
    );
};

Modal.Status = ModalCompoundStatus;
Modal.Title = ModalCompoundTitle;
Modal.Text = ModalCompoundText;
Modal.Control = ModalCompoundControl;
Modal.Body = ModalBody;

export interface IConnectedProps {
    status: EModalStatus;
}

export const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    status: makeSelectorModalStatus(),
});

export default connect(mapStateToProps)(Modal);
